module.exports = __webpack_public_path__ + "static/media/tutoring-success.16cb0c25.svg";